import { z } from 'zod';

export const bigintItemFromQuery = z.preprocess((v: unknown) => {
    if (typeof v === 'bigint') return v;

    if (typeof v === 'number') {
        if (!Number.isFinite(v) || !Number.isInteger(v)) return v;
        return BigInt(v);
    }

    if (typeof v === 'string') {
        try {
            return BigInt(v);
        } catch {
            return v;
        }
    }

    return v;
}, z.bigint());
